export default __webpack_public_path__ + "static/media/temp.b421b387.svg";